import { module } from 'angular';

import { default as pieChartDirectiveName, PieChartDirective } from './pie-chart.directive';

export default module('contact.commons.toolbox.pie-chart', []).directive(pieChartDirectiveName, PieChartDirective).name;
